import {PageContainerSkeleton, TableSkeleton, ToolbarSkeleton} from "@project/components/feedback";

import {offerTemplatesRouteApi} from "../-route-api";

export function OfferTemplatesPending() {
  const search = offerTemplatesRouteApi.useSearch();
  const perPage = search.perPage;

  return (
    <PageContainerSkeleton>
      <ToolbarSkeleton>
        <div className="flex w-full gap-3 @lg:w-auto">
          <div className="hidden @2xl:flex">
            <ToolbarSkeleton.Button />
          </div>
          <div className="flex-1 @lg:flex-none">
            <ToolbarSkeleton.Input />
          </div>
          <div className="flex @lg:hidden">
            <ToolbarSkeleton.Button className="w-10" />
          </div>
        </div>
        <ToolbarSkeleton.Actions className="hidden @lg:flex">
          <ToolbarSkeleton.Button />
        </ToolbarSkeleton.Actions>
      </ToolbarSkeleton>

      <TableSkeleton columns={4} rows={perPage} />
    </PageContainerSkeleton>
  );
}
